import scealai from '../src/assets/images/scealai.png';
import shutterstock from '../src/assets/images/shutterstock-project.png';
import healthytrinity from '../src/assets/images/healthytrinity.PNG';
import sac from '../src/assets/images/sac.png';
import pong from '../src/assets/images/pong.png';
import lunchtime from '../src/assets/images/lunchtime.png';
import microsoft from '../src/assets/images/fence.png';
import azure from '../src/assets/images/azure.png'
import docker from '../src/assets/images/docker.png'
//import fpv from '../src/assets/images/fpv.png';
import idiro from '../src/assets/images/idiro.png';

import ssql from '../src/assets/images/ssms.svg';
import tauri from '../src/assets/images/tauri.svg';
import mongoDB from '../src/assets/images/MongoDB.png';
import expressJS from '../src/assets/images/expressjs.png';
import flask from '../src/assets/images/flask.png';
import python from '../src/assets/images/python.png';
import angular from '../src/assets/images/angular.png';
import nodeJS from '../src/assets/images/nodejs.png';
import sqlite from '../src/assets/images/sqlite.png';
import ffmpeg from '../src/assets/images/ffmpeg.png';
import php from '../src/assets/images/php.png';
import dreamweaver from '../src/assets/images/dreamweaver.png';
import raylib from '../src/assets/images/raylib.png';
import cpp from '../src/assets/images/cpp.png';
import react from '../src/assets/images/react.png';
import firebase from '../src/assets/images/firebase.png';
import mysql from '../src/assets/images/mysql.png';
//import rust from '../src/assets/images/rust.png';
//import yolo from '../src/assets/images/yolo.png';
//import rocket from '../src/assets/images/rocket.png';
import ts from '../src/assets/images/ts.png'

const projects = [
    {
        id: '0',
        thumbnail: scealai,
        alt: 'An Scealai, a project I am working on under Trinity, for ABAIR',
        title: 'An Scealaí',
        type: 'ABAIR',
        text: 'An Irish language learning website run by ABAIR out of Trinity College\'s Phonetics and Speech Laboratory. ' +
        'For this project, I was tasked with integrating several learning tools with the existing website. ',
        github: 'https://github.com/OisinNolan/An-Scealai',
        website: 'https://scealai.abair.ie/',
        tech: [mongoDB, expressJS, angular, nodeJS]
    },
    {
        id: '6',
        thumbnail: microsoft,
        alt: 'A project for Microsoft I did in my third year of college.',
        title: 'Distributed Queue',
        type: 'Microsoft',
        text: 'My third year project for Trinity College\'s Computer Science course, ' + 
        'in which I lead a team of 10 other developers to build a distributed queue and a frontend to show it off. Done in collaboration with Microsoft!',
        github: 'https://github.com/SwEng-group-2-2024/distributed-queue-system',
        tech: [expressJS, nodeJS, azure, docker, react, mysql]
    },
    {
        id: '8',
        thumbnail: idiro,
        alt: 'Idiro Analytics, a company I worked for as a SwEng Intern.',
        title: 'Sentiment Summariser',
        type: 'Idiro Analytics',
        text: 'My Summer 2024 internship, in which I was tasked with ' +
        'creating an application to summarise recent news sentiment on a topic by leveraging LLMs. ' +
        'This also includes the summarisation other mediums like video and audio.',
        website: 'https://idiro.com',
        tech: [tauri, ssql, expressJS, react, nodeJS, ts]
    },
    {
        id: '1',
        thumbnail: shutterstock,
        alt: 'A project for Shutterstock I did in my second year of college.',
        title: 'On-Demand Video Transcoder',
        type: 'Shutterstock',
        text: 'My second year project for Trinity College\'s Computer Science course, ' + 
        'in which I lead a team of 3 backend developers to build an On-demand Video Transcoder. Done in collaboration with Shutterstock!',
        github: 'https://github.com/SWENG-33-2023/On-Demand-Video-Transcoding',
        tech: [expressJS, sqlite, ffmpeg, nodeJS, flask]
    },
    //{
    //    id: '7',
    //    thumbnail: fpv,
    //    alt: '4 soldiers highlighted automatically by the program.',
    //    title: 'FPV Drone AI',
    //    type: 'Personal Project',
    //    text: 'A project with the aim of creating a targeting system intended for use in FPV drones in the game \'Squad\'. Made using a custom object detection model. A lot about Rust and computer vision was learned throughout this project',
    //    github: 'https://github.com/FionnCL/fpv-computer-vision-api',
    //    tech: [rust, rocket, yolo]
    //},
    {
        id: '5',
        thumbnail: lunchtime,
        alt: 'A hackathon project(Hack Trinity). A calendar management app.',
        title: 'Lunchtime',
        type: 'Hackathon Project',
        text: 'Lunchtime is a calendar management application. Made in less than 24 hours during "Hack Trinity" in a team of 6.',
        github: 'https://github.com/FionnCL/hacktrinity',
        tech: [react, nodeJS, firebase, mysql]
    },
    {
        id: '2',
        thumbnail: pong,
        alt: 'A pong clone I made using raylib.',
        title: 'Retro Pong',
        type: 'Personal Project',
        text: 'A small project I did to introduce me to the world of game development and low-level graphics libraries. Made using raylib in C++.',
        github: 'https://github.com/FionnCL/pong',
        tech: [raylib, cpp]
    },
    {
        id: '3',
        thumbnail: sac,
        alt: 'A personal project that repurposes code that I wrote to help me with my Statistical Analysis module in college.',
        title: 'Statistical Analysis Calculator',
        type: 'Personal Project',
        text: 'A Flask application that can be used to help the user calculate a number of different values for statistical analysis.',
        github: 'https://github.com/FionnCL/statistical-analysis',
        tech: [nodeJS, flask, python]
    },
    {
        id: '4',
        thumbnail: healthytrinity,
        alt: 'Healthy trinity, the college health website I work on developing.',
        title: 'Healthy Trinity',
        type: 'Trinity College Dublin',
        text: 'One of the many jobs I did for my college was to bring their health website up to date with the current standard.',
        website: 'https://www.tcd.ie/healthytrinity/',
        tech: [php, dreamweaver]
    }
]

export default projects;
